import React, { CSSProperties, FC } from "react";

import styles from "./SurveyFrame.module.css";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ChatContainer from "../ChatContainer/ChatContainer";
import { showSurvey } from "../../features/chatbot/chatbotSlice";

const SurveyFrame: FC = () => {
  const dispatch = useAppDispatch();

  const onStartSurveyClick = () => {
    dispatch(showSurvey());
  };

  // Functions

  // State Selectors
  const { isSurveyVisible } = useAppSelector((state) => state.chatbot);
  const { isSurveyEnabled, surveyBtnLabel, surveyBtnType, surveyId, surveyType, surveyUrl } = useAppSelector((state) => state.chatConfig.chatConfig!.config.queue1.endChat);
  const { sentTypeFGColor, panelBtnBGColor, panelBtnFGColor, chatBorder } = useAppSelector((state) => state.chatConfig.chatConfig!.config.queue1.chatStyle);
  const { endChatMsg } = useAppSelector((state) => state.chatConfig.chatConfig!.config.liveChat);

  let url = "";
  if (surveyType === "campaign") {
    url = window.__PATH__?.appUrls.surveyViewer + "?cId=" + surveyId;
  } else {
    url = surveyUrl;
  }

  const btnStyles: CSSProperties = {};

  if (surveyBtnType === "button") {
    btnStyles.backgroundColor = "#" + panelBtnBGColor;
    btnStyles.color = "#" + panelBtnFGColor;
  } else {
    btnStyles.color = "#" + sentTypeFGColor;
    btnStyles.borderBottom = "solid 1px #" + chatBorder;
  }

  return (
    <ChatContainer>
      <div className={`${styles.chat_body}`}>
        {isSurveyVisible ? (
          <iframe name="SURVEY_FRAME" title="SURVEY_FRAME" src={url} />
        ) : (
          <div className={styles.end_screen} style={{ color: `#${sentTypeFGColor}` }}>
            <p>{endChatMsg || "This chat has been ended"}</p>
            {isSurveyEnabled ? (
              <span onClick={onStartSurveyClick} style={btnStyles} className={styles.action_element}>
                {surveyBtnLabel}
              </span>
            ) : null}
          </div>
        )}
      </div>
    </ChatContainer>
  );
};

export default SurveyFrame;
